var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useState, Fragment } from 'react';
import { Tabs as MuiTabs, Tab, Box } from '@material-ui/core';
import useStyles from './style';
var Tabs = function (_a) {
    var children = _a.children, _b = _a.defaultSelected, defaultSelected = _b === void 0 ? 0 : _b, onChange = _a.onChange;
    var classes = useStyles();
    var _c = useState(defaultSelected), value = _c[0], setValue = _c[1];
    var handleChange = function (event, newValue) {
        setValue(newValue);
        if (onChange)
            onChange(newValue);
    };
    useEffect(function () {
        if (typeof defaultSelected == 'number') {
            setValue(defaultSelected);
        }
    }, [defaultSelected]);
    return (_jsxs(Fragment, { children: [_jsx(Box, __assign({ className: classes.page }, { children: _jsx(MuiTabs, __assign({ value: value, onChange: handleChange, indicatorColor: "primary" }, { children: React.Children.map(children, function (child, index) { return (_jsx(Tab, { className: classes.tab, "data-testid": "panel-" + child.props.name, label: child.props.label, disabled: child.props.disabled }, index)); }) }), void 0) }), void 0),
            React.Children.map(children, function (child, index) { return (_jsx(Box, __assign({ hidden: value !== index }, { children: child }), index)); })] }, void 0));
};
var Panel = function (_a) {
    var label = _a.label, _b = _a.disabled, disabled = _b === void 0 ? false : _b, children = _a.children;
    return _jsx(_Fragment, { children: children }, void 0);
};
Tabs.Panel = Panel;
export default Tabs;
